import { toast } from "react-toastify";

export function isString(value: unknown) {
  return typeof value === "string" || value instanceof String;
}

export function handleErrorMessage(error: unknown, message: string) {
  if (isString(error)) {
    toast.error(error as string);
    return;
  }

  toast.error(message);
}

export function formatDate(date: string): string {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
});
}

export function formatDateHyphen(date: Date): string {
  return date.toISOString().split('T')[0]; 
}